import { TEEUP_LIST_MODES } from "@utils/teeupUtils"

// wave4-nav-ia: ratified navigation IA per QJ's approved layout + rulings
// (WEB-FIX-BATCH-1-2026-07-02.md item 3, design-FINAL 19:45 ET):
// logo+bell / +TeeUp / Coming Up (time surface: Coming Up + Calendar + calendar accounts) /
// Inbox (tabs live inside the page; NO Trash entry) / PlanFlow (My|Enterprise selector; Goals,
// Tasks, Booking page, Prioritize time as LIVE doors to "to discuss" pages) / People (Messages ->
// to-discuss; Relationships = renamed Contacts) / Recent (last ~5 viewed TeeUps, rendered
// dynamically in NewSidebar.js) / bottom avatar+name menu (Profile, Settings, Log out).
const SIDEBAR_GROUPS = {
  COMING_UP: "Coming Up",
  PLANFLOW: "PlanFlow",
  PEOPLE: "People",
}

export const SIDEBAR_MENU_NAMES = {
  AI_CREATE: "AI Create",
  CREATE: "+ TeeUp",
  INBOX: "Inbox",
  TRASH: "Trash",
  COMING_UP: "Coming Up",
  ALL: "All",
  CONTACTS: "Contacts",
  SETTINGS: "Settings",
  PROFILE: "Profile",
}

// wave4-nav-ia fix2: the common menu is now rendered as a FIXED structure directly in
// NewSidebar.js (qj-nav block) -- this constant remains only for the ?option= effect and any
// legacy consumer. "+ AI Create" and "+ Create new..." are REMOVED entirely (never specced);
// the single "+ TeeUp" button lives in the qj-nav block.
export const COMMON_SIDEBAR_MENU = [
  {
    // Coming Up = THE time surface (QJ spec decision, logged to PA): today's Coming Up view,
    // the calendar views, and calendar-account/subscribe management all live here.
    name: SIDEBAR_GROUPS.COMING_UP,
    items: [
      {
        index: 4,
        name: "Coming Up",
        icon: "coming-up",
        pathname: "/coming-up",
        testId: "nav-coming-up",
        group: SIDEBAR_GROUPS.COMING_UP,
      },
      {
        index: 5,
        name: "Calendar",
        icon: "thin-calendar",
        pathname: "/calendar",
        testId: "nav-calendar",
        group: SIDEBAR_GROUPS.COMING_UP,
      },
      {
        index: 8,
        name: "Calendar accounts",
        icon: "menu-calendar",
        pathname: "/settings",
        option: "calendars",
        testId: "nav-calendar-accounts",
        group: SIDEBAR_GROUPS.COMING_UP,
      },
    ],
  },
  {
    name: "",
    items: [
      {
        // Inbox: Active tab w/ Invitations/Scheduled/Unscheduled/Ended + user-status filter
        // chips and the Archive tab all live INSIDE the page (already built, reuses the existing
        // category/status query params). NO Trash entry per QJ ruling.
        index: 1,
        name: SIDEBAR_MENU_NAMES.INBOX,
        icon: "inbox-2",
        pathname: "/inbox",
        testId: "nav-inbox",
      },
    ],
  },
  {
    // PlanFlow = the configuration hub (QJ spec decision, logged to PA). My|Enterprise selector
    // is rendered by NewSidebar.js at the top of this group; every unbuilt destination is a LIVE
    // door to its "to discuss" page (QJ ruling: no dead/greyed doors).
    name: SIDEBAR_GROUPS.PLANFLOW,
    items: [
      {
        index: 9,
        name: "Goals",
        icon: "check-circle",
        pathname: "/discuss/goals",
        testId: "nav-goals",
        group: SIDEBAR_GROUPS.PLANFLOW,
      },
      {
        index: 10,
        name: "Tasks",
        icon: "check",
        pathname: "/discuss/tasks",
        testId: "nav-tasks",
        group: SIDEBAR_GROUPS.PLANFLOW,
      },
      {
        index: 17,
        name: "Booking page",
        icon: "menu-calendar",
        pathname: "/discuss/booking-page",
        testId: "nav-booking-page",
        group: SIDEBAR_GROUPS.PLANFLOW,
      },
      {
        index: 18,
        name: "Prioritize time",
        icon: "timezone",
        pathname: "/discuss/prioritize-time",
        testId: "nav-prioritize-time",
        group: SIDEBAR_GROUPS.PLANFLOW,
      },
    ],
  },
  {
    name: SIDEBAR_GROUPS.PEOPLE,
    items: [
      {
        index: 19,
        name: "Messages",
        icon: "menu-emails",
        pathname: "/discuss/messages",
        testId: "nav-messages",
        group: SIDEBAR_GROUPS.PEOPLE,
      },
      {
        // Relationships = the existing Contacts view renamed (incl. contacts), per QJ layout.
        index: 6,
        name: "Relationships",
        icon: "contacts-2",
        pathname: "/contacts",
        testId: "nav-relationships",
        group: SIDEBAR_GROUPS.PEOPLE,
      },
    ],
  },
]
export const SETTINGS_SIDEBAR_MENU = [
  {
    name: "",
    title: "Settings",
    items: [
      // WB2 (Wave 3): "profile" is a real screen (moreView.js's screens[2], renders
      // UserProfileContainer -> the working EditUserProfileContainer name/avatar edit form) but
      // had NO entry here. That's a real gap on two counts: (1) it meant Settings > Profile was
      // unreachable from the sidebar UI at all; (2) NewSidebar.js's `?option=` search-param
      // handler does `items.findIndex(item => item.option === option)` then unconditionally
      // `setActiveRoute(items[index])` -- for any option missing from this list that's -1 ->
      // `items[-1]` -> undefined -> a hard crash ("Cannot read properties of undefined (reading
      // 'option')") the next time anything reads `activeRoute.option`. Confirmed live: navigating
      // straight to `/settings?option=profile` (the only way to reach the name/avatar edit form)
      // crashed the whole settings page before this fix.
      {
        index: 0,
        name: "Profile",
        icon: "user-account",
        pathname: "/settings",
        option: "profile",
      },
      {
        index: 1,
        name: "Account settings",
        icon: "user-account",
        pathname: "/settings",
        option: "accountManagement",
      },
      {
        index: 1,
        name: "See invitations sent to",
        icon: "menu-emails",
        pathname: "/settings",
        option: "invitationsDetails",
      },
      {
        index: 2,
        name: "Sync contacts",
        icon: "sync-contacts",
        pathname: "/settings",
        option: "syncContacts",
      },
      {
        index: 3,
        name: "Calendars",
        icon: "menu-calendar",
        pathname: "/settings",
        option: "calendars",
      },
      {
        index: 4,
        name: "Time zones",
        icon: "timezone",
        pathname: "/settings",
        option: "timezones",
      },
      {
        index: 5,
        name: "Notifications",
        icon: "notification",
        pathname: "/settings",
        option: "notificationSettings",
      },
    ],
  },
]

export const SETTINGS_BOTTOM_SIDEBAR_MENU = [
  // wave4-fix22: privacy.coowe.com / tos.coowe.com are dead -- in-app pages, same-tab
  { index: 16, name: "Privacy Policy", pathname: "/privacy" },
  { index: 15, name: "Terms of Service", pathname: "/terms" },
  // wave4-fix12: licenses.coowe.com is dead (new-window fail + bounce) -- in-app page instead
  { index: 14, name: "Licenses", pathname: "/licenses" },
]

export const NEW_SIDEBAR_MENU = {
  settings: SETTINGS_SIDEBAR_MENU,
  common: COMMON_SIDEBAR_MENU,
}

export const BOTTOM_SIDEBAR_MENU = {
  settings: SETTINGS_BOTTOM_SIDEBAR_MENU,
  common: [],
}

// TODO: remove together with old components
export const SIDEBAR_MENU = {
  CREATE: {
    INDEX: 0,
    PATHNAME: "/create",
  },
  INBOX: {
    INDEX: 1,
    PATHNAME: "/inbox",
    TEEUPS_MODE: TEEUP_LIST_MODES.ACTIVE,
  },
  ARCHIVE: {
    INDEX: 2,
    PATHNAME: "/archive",
    TEEUPS_MODE: TEEUP_LIST_MODES.ARCHIVED,
  },
  TRASH: {
    INDEX: 3,
    PATHNAME: "/trash",
    TEEUPS_MODE: TEEUP_LIST_MODES.SKIPPED,
  },
  COMING_UP: {
    INDEX: 4,
    PATHNAME: "/coming-up",
    TEEUPS_MODE: TEEUP_LIST_MODES.COMING_UP,
  },
  CALENDAR: {
    INDEX: 5,
    PATHNAME: "/calendar",
  },
  CONTACTS: {
    INDEX: 6,
    PATHNAME: "/contacts",
  },
  SETTINGS: {
    INDEX: 11,
    PATHNAME: "/settings",
  },
  HELP: {
    INDEX: 12,
    PATHNAME: "/mock-HELP",
  },
  MY_PROFILE: {
    INDEX: 13,
    PATHNAME: "/my-profile",
  },
  MY_PROFILE_2: {
    INDEX: 14,
    PATHNAME: "/profile-2/:id",
  },
}
